import { Link } from 'react-router-dom';

export default function CaseCTA() {
  return (
    <section className="py-24 bg-zinc-900/40 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-zinc-700/40 to-transparent" />

      {/* Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] rounded-full bg-orange-500/8 blur-3xl pointer-events-none" />
      <div
        className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{ backgroundImage: 'radial-gradient(circle, #f97316 1px, transparent 1px)', backgroundSize: '36px 36px' }}
      />

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center">
        <div className="inline-flex items-center gap-2 bg-zinc-800/60 border border-zinc-700/40 rounded-full px-4 py-1.5 mb-8">
          <i className="ri-rocket-2-line text-orange-400 text-sm" />
          <span className="text-zinc-300 text-sm font-semibold">Chcete podobné výsledky?</span>
        </div>

        <h2 className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight">
          Váš biznis môže byť{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-amber-400">
            ďalší príbeh úspechu.
          </span>
        </h2>
        <p className="text-zinc-400 text-xl mb-10 max-w-2xl mx-auto leading-relaxed">
          Začnite bezplatnou 30-minútovou analýzou. Zistíte presne, koľko zákazníkov
          o vás prichádza každý deň - a čo s tým urobíme.
        </p>

        {/* CTA buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <Link
            to="/#kontakt"
            className="inline-flex items-center gap-2.5 bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-400 hover:to-amber-400 text-white font-bold px-8 py-4 rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap text-base"
          >
            <i className="ri-gift-line" />
            Získať bezplatnú analýzu
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2.5 border border-zinc-700 hover:border-zinc-500 text-white font-semibold px-8 py-4 rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap text-base"
          >
            <i className="ri-arrow-left-line" />
            Späť na referencie
          </Link>
        </div>

        {/* Trust signals */}
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {[
            { icon: 'ri-time-line', text: 'Odpoveď do 24 hodín' },
            { icon: 'ri-shield-check-line', text: 'Bez záväzkov' },
            { icon: 'ri-customer-service-2-line', text: '9+ rokov skúseností' },
            { icon: 'ri-user-star-line', text: '120+ spokojných klientov' },
          ].map((t) => (
            <div key={t.text} className="flex items-center gap-2 text-zinc-500">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${t.icon} text-orange-400/70 text-sm`} />
              </div>
              <span className="text-sm">{t.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
